import React from 'react';
import {NavLink, useLocation} from "react-router";
import {Box} from "@mui/material";

/**
 * True when pathname equals prefix or is a nested path under it.
 * e.g. "/icr" matches "/icr", "/icr/ABC", "/icr/eei/1"
 */
export function pathMatchesPrefix(pathname, prefix) {
    if (!pathname || !prefix) return false;
    const normalized = prefix.length > 1 && prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    return pathname === normalized || pathname.startsWith(`${normalized}/`);
}

const NavItem = ({destination, label, activePrefixes}) => {
    const {pathname} = useLocation();

    return (
        <NavLink
            to={destination}
            style={{textDecoration: 'none'}}
        >
            {({isActive: linkIsActive}) => {
                const isActive = Array.isArray(activePrefixes) && activePrefixes.length > 0
                    ? activePrefixes.some((prefix) => pathMatchesPrefix(pathname, prefix))
                    : linkIsActive;

                return (
                    <Box
                        sx={{
                            px: 1.25,
                            py: 0.625,
                            fontSize: 'inherit',
                            fontWeight: 600,
                            letterSpacing: 0.1,
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            userSelect: 'none',
                            bgcolor: isActive ? 'primary.main' : 'transparent',
                            color: isActive ? 'primary.contrastText' : 'text.secondary',
                            transition: 'background-color 150ms cubic-bezier(0.4,0,0.2,1), color 150ms cubic-bezier(0.4,0,0.2,1), box-shadow 150ms cubic-bezier(0.4,0,0.2,1)',
                            '&:hover': {
                                bgcolor: isActive ? 'primary.dark' : 'action.selected',
                                color: isActive ? 'primary.contrastText' : 'primary.main',
                            },
                        }}
                    >
                        {label}
                    </Box>
                );
            }}
        </NavLink>
    );
};

export default NavItem;
